export const ER_CONTENT = {
  hero: {
    kicker: 'Para locadoras de máquinas e equipamentos',
    title: 'Seu parque de equipamentos está organizado, ou só na cabeça de quem trabalha há mais tempo?',
    subtitle:
      'Inventário completo, histórico de manutenção por equipamento e proposta/contrato de locação em PDF — tudo em um só sistema, sem depender de planilha ou de perguntar para quem "sabe de cabeça".',
    cta: 'Quero organizar meu parque de equipamentos',
    ctaMessage: 'Quero conhecer o sistema para locadora de equipamentos do 77Gestão',
    urgency: 'Enquanto o controle depende de memória, um equipamento pode sair sem manutenção em dia ou o contrato sair sem padrão.',
  },

  statsStrip: [
    { number: '1 cadastro', label: 'por equipamento, com todo o histórico', icon: 'fa-solid fa-clipboard-list' },
    { number: 'Registrado', label: 'todo o histórico de manutenção', icon: 'fa-solid fa-screwdriver-wrench' },
    { number: '1 sistema', label: 'para inventário, contrato e cliente', icon: 'fa-solid fa-toolbox' },
  ],

  pain: {
    title: 'Reconhece alguma dessas situações na sua locadora?',
    intro:
      'Quem loca equipamento sabe: sem um cadastro organizado, cada consulta sobre um equipamento vira uma busca na memória de alguém.',
    items: [
      { icon: 'fa-solid fa-magnifying-glass', text: 'Informação de cada equipamento (histórico, valor de aquisição, observações) espalhada entre planilha, papel e memória de quem trabalha há mais tempo.' },
      { icon: 'fa-solid fa-screwdriver-wrench', text: 'Sem histórico de manutenção organizado, fica difícil saber quando foi a última revisão de cada máquina.' },
      { icon: 'fa-solid fa-file-signature', text: 'Contrato de locação feito manualmente, em modelo de Word ou papel, sem padrão nem histórico organizado.' },
      { icon: 'fa-regular fa-clock', text: 'Cliente liga (ou aparece) perguntando informações do equipamento e a resposta demora porque ninguém acha o histórico na hora.' },
      { icon: 'fa-solid fa-clock-rotate-left', text: 'Sem histórico de manutenção por equipamento, fica difícil saber qual máquina está gerando mais custo de reparo.' },
    ],
  },

  midCta: {
    text: 'E se você abrisse o sistema e visse, na hora, o cadastro completo e o histórico de manutenção de cada equipamento?',
    cta: 'Quero ver na prática',
    ctaMessage: 'Quero ver uma demonstração do sistema para locadora de equipamentos do 77Gestão',
  },

  solution: {
    title: 'Todo equipamento com cadastro, histórico e contrato organizados.',
    intro:
      'O 77Gestão organiza o que sua locadora tem, o histórico de manutenção de cada equipamento e o contrato de cada cliente — tudo no mesmo sistema.',
    cards: [
      {
        icon: 'fa-solid fa-clipboard-list',
        title: 'Inventário completo de equipamentos',
        text: 'Cadastre cada máquina ou equipamento com data de aquisição, valor e observações, num único lugar acessível para toda a equipe.',
      },
      {
        icon: 'fa-solid fa-screwdriver-wrench',
        title: 'Histórico de manutenção por equipamento',
        text: 'Registre cada manutenção preventiva e corretiva, com data, valor e comprovante, para consultar antes de decidir sobre uma nova locação.',
      },
      {
        icon: 'fa-solid fa-file-signature',
        title: 'Proposta e contrato de locação vinculados',
        text: 'Gere a proposta/contrato de locação em PDF já vinculado ao cliente, sem montar documento do zero a cada aluguel.',
      },
      {
        icon: 'fa-solid fa-address-book',
        title: 'Histórico do cliente',
        text: 'Veja o histórico de propostas e negociações de cada cliente PF ou PJ, incluindo documentos, sempre que for negociar de novo.',
      },
      {
        icon: 'fa-solid fa-file-invoice-dollar',
        title: 'Faturamento integrado',
        text: 'Emita nota fiscal e controle o financeiro da locadora sem sair do mesmo sistema que guarda o cadastro do equipamento.',
      },
    ],
  },

  proof: {
    title: 'O que muda quando a locadora para de depender da memória de alguém',
    intro:
      'Uma locadora de equipamentos para construção civil controlava o parque de máquinas de cabeça e em anotações soltas, e vivia com dúvida sobre quando cada equipamento tinha passado pela última manutenção.',
    stats: [
      { number: '100%', label: 'dos equipamentos com cadastro e histórico organizados' },
      { number: '1 lugar', label: 'para inventário, manutenção e contrato' },
      { number: 'Rápido', label: 'para consultar o histórico de um equipamento' },
    ],
    paragraphs: [
      'Depois da implantação, cada equipamento passou a ter cadastro e histórico de manutenção acessíveis para toda a equipe, sem depender de quem "lembra de cabeça".',
      'A proposta de locação passou a sair vinculada ao cliente, reduzindo o tempo entre o contato e o fechamento do contrato.',
    ],
    highlight: 'Resultado: cadastro organizado, histórico de manutenção confiável e contrato padronizado.',
    cta: 'Quero esse nível de organização',
    ctaMessage: 'Vi o resultado e quero entender como organizar minha locadora de equipamentos no 77Gestão',
  },

  benefits: {
    title: 'Os três pilares que mudam a gestão da locadora',
    items: [
      {
        icon: 'fa-solid fa-eye',
        title: 'Visibilidade',
        text: 'Cadastro e histórico de manutenção de cada equipamento acessíveis para toda a equipe, a qualquer momento.',
      },
      {
        icon: 'fa-solid fa-sliders',
        title: 'Controle',
        text: 'Manutenção registrada por equipamento, sem depender de memória ou de anotação solta.',
      },
      {
        icon: 'fa-solid fa-binoculars',
        title: 'Previsibilidade',
        text: 'Histórico de manutenções ajuda a decidir quando revisar um equipamento antes que vire problema.',
      },
    ],
  },

  differentials: {
    title: 'Por que locadoras escolhem o 77Gestão',
    items: [
      { icon: 'fa-solid fa-link', text: 'Inventário, manutenção, proposta e financeiro integrados — um lançamento alimenta tudo.' },
      { icon: 'fa-solid fa-puzzle-piece', text: 'Sistema adaptável ao tamanho do parque de equipamentos, de poucas máquinas a um parque grande.' },
      { icon: 'fa-solid fa-handshake', text: 'Implantação acompanhada: sua equipe começa a usar com o inventário já cadastrado.' },
      { icon: 'fa-solid fa-headset', text: 'Suporte humano, próximo e muito bem avaliado.' },
    ],
  },

  faq: {
    title: 'Perguntas comuns antes de começar',
    items: [
      {
        question: 'O sistema controla se um equipamento está alugado ou disponível no momento?',
        answer:
          'Não. O 77Gestão organiza o cadastro do equipamento, seu histórico de manutenção e a proposta/contrato de locação vinculado ao cliente — não é um sistema de reserva com controle de disponibilidade em tempo real.',
      },
      {
        question: 'O sistema controla contrato de locação com cláusulas específicas?',
        answer:
          'O sistema gera a proposta/contrato de locação em PDF vinculado ao equipamento e ao cliente, com os dados da negociação organizados — sem precisar montar o documento do zero a cada aluguel.',
      },
      {
        question: 'Dá para saber quando foi a última manutenção de um equipamento?',
        answer:
          'Sim. A manutenção preventiva e corretiva é registrada por equipamento, então dá para consultar o histórico completo antes de decidir sobre uma nova locação.',
      },
      {
        question: 'Tenho poucos equipamentos hoje, mas pretendo crescer. O sistema aguenta?',
        answer:
          'Sim. O inventário é feito para acompanhar o crescimento do parque de equipamentos, de poucas unidades a uma operação maior.',
      },
      {
        question: 'Minha locadora já usa planilha há anos. É difícil migrar?',
        answer:
          'Não precisa migrar sozinho. A implantação é acompanhada, com o inventário sendo cadastrado junto com a equipe, no ritmo da operação.',
      },
    ],
  },

  ctaFinal: {
    title: 'Pare de depender da memória de alguém. Tenha o cadastro e o histórico do seu parque de equipamentos organizados.',
    subtitle:
      'Agende uma demonstração e veja, na prática, como organizar inventário, manutenção e contrato de locação em um único sistema.',
    cta: 'Agendar demonstração agora',
    ctaMessage: 'Quero agendar uma demonstração do sistema para locadora de equipamentos do 77Gestão',
  },

  seo: {
    title: 'Sistema para Locadora de Equipamentos | 77Gestão',
    description:
      'Software para locação de máquinas e equipamentos: inventário completo, histórico de manutenção e proposta/contrato vinculado ao cliente. Agende uma demonstração.',
  },
};
